import { filter as _filter } from 'lodash';
import { UserModel, ConfigurationModel } from 'franke-trough-dependencies';

export const filterConfigurationsBySword = (configurations: ConfigurationModel[] | undefined, sword: string = ''): ConfigurationModel[] | undefined => {
  if (!configurations || !sword) { return configurations; }
  sword = sword.toLowerCase();

  const filteredConfigurations: any = _filter(configurations, (configuration) => {
    const name = configuration.name.toLowerCase();
    const matchesName = name.includes(sword);
    const sapNumber = configuration.sapNumber && configuration.sapNumber.toLowerCase();
    const matchesSapNumber = sapNumber && sapNumber.includes(sword);
    return (matchesName || matchesSapNumber);
  });

  return filteredConfigurations as ConfigurationModel[];
}

export const filterUsersBySword = (users: UserModel[] | undefined, sword: string = ''): UserModel[] | undefined => {
  if (!users || !sword) { return users; }
  sword = sword.toLowerCase();

  const filteredUsers: any = _filter(users, (user) => {
    const email = user.email.toLowerCase();
    const matchesEmail = email.includes(sword);
    const firstName = user.userData && user.userData.firstName.toLowerCase();
    const matchesFirstName = firstName && firstName.includes(sword);
    const lastName = user.userData && user.userData.lastName.toLowerCase();
    const matchesLastName = lastName && lastName.includes(sword);
    return (matchesEmail || matchesFirstName || matchesLastName);
  });

  return filteredUsers as UserModel[];
}

export const filterUsersByRole = (users: UserModel[] | undefined, role: string): UserModel[] | undefined => {
  if (!users || !role) { return users; }

  const filteredUsers: any = _filter(users, (user) => {
    const roles = user.roles;
    if (!roles) { return false; }

    const matchingRoles = _filter(roles, (r) => r.name === role);

    return matchingRoles.length > 0;
  });

  return filteredUsers as UserModel[];
}

export const filterUsersById = (users: UserModel[] | undefined, userId: string | undefined): UserModel[] | undefined => {
  if (!users) { return users; }

  const filteredUsers: any = _filter(users, (user) => {
    return user.id === userId;
  });

  return filteredUsers as UserModel[];
}

export const filterUsersWithoutId = (users: UserModel[] | undefined, userId: string): UserModel[] | undefined => {
  if (!users) { return users; }

  const filteredUsers: any = _filter(users, (user) => {
    return user.id !== userId;
  });

  return filteredUsers as UserModel[];
}

export const userIsAdmin = (user: UserModel) => {
  const roles = user.roles;
  if (!roles) { return false; }
  const internalRoles = _filter(roles, (r) => r.name === 'useradmin');
  return internalRoles.length > 0;
}

export const userIsInternal = (user: UserModel | undefined) => {
  if (!user) { return false; }
  const roles = user.roles;
  if (!roles) { return false; }
  const internalRoles = _filter(roles, (r) => r.name === 'internal');
  return internalRoles.length > 0;
}

export const userIsExternal = (user: UserModel | undefined) => {
  if (!user) { return true; }
  const roles = user.roles;
  if (!roles || roles.length === 0) { return true; }
  return false;
}

export const userIsSalesRep = (user: UserModel | undefined) => {
  if (!user) { return false; }
  const roles = user.roles;
  if (!roles) { return false; }
  const salesRepRoles = _filter(roles, (r) => r.name === 'salesrep');
  return salesRepRoles.length > 0;
}

export const userHasRole = (user: UserModel | undefined, role: string) => {
  if (!user) { return false; }
  const roles = user.roles;
  if (!roles) { return false; }
  const salesRepRoles = _filter(roles, (r) => r.name === role);
  return salesRepRoles.length > 0;
}

export const userExistsInArray = (users: UserModel[], user: UserModel) => {
  const matchingUsers = _filter(users, (u) => u.id === user.id);
  return matchingUsers.length > 0;
}